import type { Insurer } from 'BrokerTsLib/src/enums'
import { logos as baseLogos } from 'BrokerTsLib/src/utils'
import respect_assistance from '../assets/images/companies-logos/respect_assistance_logo.png'
import subaru_pojisteni from '../assets/images/companies-logos/subaru_pojisteni.png'

type Logos = Map<Insurer | SpecialLogoIds, string>

const SpecialLogoIds = {
  SubaruPojisteni: 1002,
  RespectAssistance: 2019,
} as const

type SpecialLogoIds = typeof SpecialLogoIds[keyof typeof SpecialLogoIds]

export { SpecialLogoIds }

const logos: Logos = new Map([
  ...baseLogos,
  [SpecialLogoIds.SubaruPojisteni, subaru_pojisteni],
  [SpecialLogoIds.RespectAssistance, respect_assistance],
])

export const getLogo = (insurerId: Insurer | SpecialLogoIds): string | undefined => {
  return logos.get(insurerId)
}